import React from 'react';
import {
  BrandThemeColorToolTip,
  BrandThemeTextToolTip,
  ButtonColorToolTip,
  LandingHeadlineColorToolTip,
  LandingIntroCopyColorToolTip,
  LegalTextColorToolTip,
  LockedOverlayColorToolTip,
  MobileLandingHeadlineColorToolTip,
  MobileLandingIntroCopyColorToolTip,
  PageBkgdToolTip,
  ProgressBarBkgdColorToolTip,
  ProgressBarFailBkgdColorToolTip,
  ProgressBarSuccessBkgdColorToolTip,
  ProgressBarTextColorToolTip,
  ReplayTextBkgdColorToolTip,
  ReplayTextColorToolTip,
  SelectPaletteToolTip,
  SponsorNameColorToolTip
} from "components/break/tooltips/breaks-color-section-tool-tips";
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import { isNewLayout } from 'utils/break-utils';

export default {
    key: "breaksColorSection",
    showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored'),
    props: {
        headerKey: 'editbreak.section.color.heading'
    },
    fields: [
        {
            type: 'color',
            name: 'themeColor1',
            required: false,
            showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.themeColor1',
            }
        },
        {
            type: 'color',
            name: 'themeColor2',
            required: false,
            showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.themeColor2',
            }
        },
        {
            type: 'color',
            name: 'themeColor3',
            required: false,
            showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.themeColor3',
            }
        },
        {
            type: 'color',
            name: 'themeColor4',
            required: false,
            showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.themeColor4',
            }
        },

        {
          type: 'color',
          name: 'themeColor5',
          required: false,
          showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
          props: {
              labelKey: 'editbreak.colors.themeColor5',
          }
        },

        {
          type: 'color',
          name: 'themeColor6',
          required: false,
          showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
          props: {
              labelKey: 'editbreak.colors.themeColor6',
          }
        },

        {
            type: 'ColorPaletteDropdown', //<- change to custom name. look at MultiPlatformFieldcomponents
            name: 'colorPalette',
            required: false,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: <FormattedMessage id={'editbreak.colors.colorPalette'}/>,
                helpContent: <SelectPaletteToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.colorPalette'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'backgroundColor',
            // showField: (proxy) => {
            //     console.log(proxy)
            //     console.log(isNewLayout(proxy.currentBaseResource))
            //     return true
            // } ,
            //   showField: (proxy) =>  (!proxy.currentResource.useDefaultImage && !isNewLayout(proxy.currentBaseResource)),
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.pageBg',
                helpContent: <PageBkgdToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.pageBg'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'missionColor1',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.brandThemeColor',
                helpContent: <BrandThemeColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.brandThemeColor'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'missionColor6',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.brandThemeText',
                helpContent: <BrandThemeTextToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.brandThemeText'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'missionColor5',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.buttonColor',
                helpContent: <ButtonColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.buttonColor'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'missionColor3',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.lockedOverlayColor',
                helpContent: <LockedOverlayColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.lockedOverlayColor'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'replayColor',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.replayText',
                helpContent: <ReplayTextColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.replayText'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'missionColor7',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.resultPageTextBg',
                helpContent: <ReplayTextBkgdColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.resultPageTextBg'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'questionNavColor',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.progressBarMainBg',
                helpContent: <ProgressBarBkgdColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.progressBarMainBg'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'questionNavTextColor',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.progressBarText',
                helpContent: <ProgressBarTextColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.progressBarText'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'questionNavCorrectColor',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.progressBarSuccessBg',
                helpContent: <ProgressBarSuccessBkgdColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.progressBarSuccessBg'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'questionNavIncorrectColor',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.progressBarFailBg',
                helpContent: <ProgressBarFailBkgdColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.progressBarFailBg'}/></IntlProvider>,
            }
        },
        {
          type: 'color',
          name: 'landingPageHeadlineColor',
          required: true,
          showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'editbreak.colors.landing_page_headline_color',
            helpContent: <LandingHeadlineColorToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.landing_page_headline_color'}/></IntlProvider>,
          }
        },
        {
          type: 'color',
          name: 'mobileLandingPageHeadlineColor',
          required: true,
          showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'editbreak.colors.mobile_landing_page_headline_color',
            helpContent: <MobileLandingHeadlineColorToolTip/>,
          helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.mobile_landing_page_headline_color'}/></IntlProvider>,
          }
        },
        {
          type: 'color',
          name: 'landingPageIntroColor',
          required: true,
          showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'editbreak.colors.landing_page_intro_color',
            helpContent: <LandingIntroCopyColorToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.landing_page_intro_color'}/></IntlProvider>,
          }
        },
        {
          type: 'color',
          name: 'mobileLandingPageIntroColor',
          required: true,
          showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'editbreak.colors.mobile_landing_page_intro_color',
            helpContent: <MobileLandingIntroCopyColorToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.mobile_landing_page_intro_color'}/></IntlProvider>,
          }
        },
        {
          type: 'color',
          name: 'websiteCopyColor',
          required: true,
          showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'editbreak.colors.website_copy_color'
          }
        },
        {
          type: 'color',
          name: 'mobileWebsiteCopyColor',
          required: true,
          showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'editbreak.colors.mobile_website_copy_color'
          }
        },
        {
            type: 'color',
            name: 'termsColor',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.termsColor',
                helpContent: <LegalTextColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.termsColor'}/></IntlProvider>,
            }
        },
        {
            type: 'color',
            name: 'sponsor',
            required: true,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.sponsorName',
                helpContent: <SponsorNameColorToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.colors.sponsorName'}/></IntlProvider>,
            }
        },
        {
          name: 'useNavAndFooterColor',
          conditionalSection: true,
          showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'editbreak.colors.useNavAndFooterColor'
          },

          fields: [
            {
              type: 'color',
              name: 'navAndFooterBackgroundColor',
              showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
              props: {
                labelKey: 'editbreak.colors.navAndFooterBackgroundColor'
              }
            },
            {
              type: 'color',
              name: 'navAndFooterFontColor',
              showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
              props: {
                labelKey: 'editbreak.colors.navAndFooterFontColor'
              }
            },
            {
              type: 'blackOrWhiteDropdown',
              name: 'navAndFooterImageColor',
              showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
              props: {
                labelKey: 'editbreak.colors.navAndFooterImageColor'
              }
            }
          ]
        },
        {
            type: 'textarea',
            name: 'customCss',
            required: false,
            showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
            props: {
                labelKey: 'editbreak.colors.customCss',
            }
        },

        {
          type: 'savePaletteMessage',
        }
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksColorSection.js